"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var findPeopleByEmail_1 = require("../services/people/findPeopleByEmail");
var owa_trace_1 = require("owa-trace");
var owa_analytics_1 = require("owa-analytics");
var datapoints_1 = require("../datapoints");
function getPersonaByEmail(emailAddress, displayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var people, contacts, response, _a, personasForDisplayName, personaToReturn;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    people = findPeopleByEmail_1.findPeopleByEmail(emailAddress);
                    return [4 /*yield*/, findPeopleByEmail_1.findContactsByEmail(emailAddress)];
                case 1:
                    contacts = _b.sent();
                    if (!(contacts.personas && contacts.personas.length > 0)) return [3 /*break*/, 2];
                    _a = contacts;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, people];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    // We can get several hits for the given email with different displayNames, to avoid confusion for the user
                    // we use the one favorited
                    if (response.personas && response.personas.length > 0) {
                        personasForDisplayName = response.personas.filter(function (persona) { return persona.DisplayName === displayName; });
                        if (personasForDisplayName.length > 0) {
                            return [2 /*return*/, personasForDisplayName[0]];
                        }
                        personaToReturn = response.personas[0];
                        // Contact from the recipient cache without a proper displayName,
                        // fall back on the provided display name
                        if (personaToReturn.DisplayName === emailAddress &&
                            personaToReturn.EmailAddress.MailboxType === 'OneOff') {
                            owa_analytics_1.logUsage(datapoints_1.default.OneOffAddressUsedForFavorite.datapoint.name);
                            return [2 /*return*/, tslib_1.__assign({}, personaToReturn, { DisplayName: displayName })];
                        }
                        return [2 /*return*/, personaToReturn];
                    }
                    else {
                        owa_trace_1.trace.warn("Cannot find persona by email: " + emailAddress);
                        throw new Error("Persona not found (people: " + response.requestId + ", contacts: " + contacts.requestId + ", length: " + (emailAddress ? emailAddress.length : 'no email address') + ")");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = getPersonaByEmail;
//# sourceMappingURL=getPersonaByEmail.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/util/getPersonaByEmail.js
// module id = 3165
// module chunks = 14 68